import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Construction from "@/pages/Construction";
import ManpowerSolutionsPage from "@/pages/ManpowerSolutionsPage";
import WhyFrontx from "@/pages/WhyFrontx";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/industries" element={<Industries />} />
                    <Route path="/construction" element={<Construction />} />
                    <Route path="/manpower-solutions" element={<ManpowerSolutionsPage />} />
                    <Route path="/why-frontx" element={<WhyFrontx />} />
                    <Route path="/careers" element={<Careers />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy" element={<Legal page="privacy" />} />
                    <Route path="/terms" element={<Legal page="terms" />} />
                    <Route path="/disclaimer" element={<Legal page="disclaimer" />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </Layout>
            <Toaster position="top-center" richColors closeButton />
        </BrowserRouter>
    );
}

export default App;
